// @ts-strict-ignore
import type { AggregationSourceData } from './types';
import type { Option } from '@usealloy/component-library';
import { AggregationType, TimeframeUnit } from 'flow/store/engine/constants';

// TODO(OAK-1060): Remove INITIAL_AGGREGATION_CONFIG once all sourceData
// fields (scope, timeframe) are persisted in AggregationComponent and
// transformations are complete.
export const INITIAL_AGGREGATION_CONFIG: AggregationSourceData = {
  name: 'Entities',
  description: '',
  aggregation: {
    columnSlug: 'entity_token',
    aggregationType: AggregationType.COUNT_DISTINCT,
  },
  scope: 'all',
  filters: [],
  timeframeIntervalStart: 0,
  timeframeIntervalEnd: 30,
  timeframeUnit: TimeframeUnit.DAYS,
  showTimeframeFilter: true,
};

// Matches ClientQueryDataConfigFilters.display_name (VARCHAR(96)), which is
// where an aggregation's name lands. Exceeding it fails the save in Postgres.
export const AGGREGATION_NAME_MAX_LENGTH = 96;

export const SCOPE_MAX_DAYS = {
  all: 90,
  entity: 365,
  group: 365,
} as const;

// Shown when a user opens the aggregation editor for an object whose active
// version isn't selectable (active_selects === false), e.g. an existing rule
// on an object that has since been deactivated.
export const INACTIVE_AGGREGATION_OBJECT_MESSAGE = "This object isn't active right now, so it can't be edited. Please try again later.";

export const AGGREGATION_TYPE_LABELS: Record<AggregationType, string> = {
  [AggregationType.COUNT_DISTINCT]: 'Distinct Count',
  [AggregationType.SUM]: 'Sum',
  [AggregationType.AVG]: 'Average',
  [AggregationType.MIN]: 'Min',
  [AggregationType.MAX]: 'Max',
};

export const BOOLEAN_FILTER_OPTIONS: Option[] = [
  { value: 'true', label: 'true' },
  { value: 'false', label: 'false' },
];

export const REFERENCE_FIELD_PLACEHOLDER = 'select field';

export const SCOPE_OPTIONS: (Option & { tooltipText?: string })[] = [
  { value: 'all', label: 'Across all Entities', tooltipText: 'Calculates velocity across all entities' },
  { value: 'entity', label: 'For the Entity being evaluated' },
  { value: 'group', label: 'For all Entities in this Group' },
];

// A portfolio evaluation runs the aggregation across every entity and groups the results, so the
// scope is fixed. It persists as 'all' -- no entity_token filter is emitted -- and inherits that
// scope's timeframe maximum, which is deliberate: a portfolio aggregation scans every entity
// across the window rather than one, so it is the more expensive case, not the less.
export const PORTFOLIO_SCOPE_OPTIONS: (Option & { tooltipText?: string })[] = [
  { value: 'all', label: 'For each Entity being evaluated' },
];

export const TIMEFRAME_UNIT_OPTIONS: Option[] = Object.values(TimeframeUnit).map(
  value => ({ value, label: value }),
);
